export default {"src":"/_next/static/media/example-mob.038e9b44.svg","height":291,"width":350,"blurWidth":0,"blurHeight":0};